export namespace Loader {
  export interface State {
    progress: boolean;
  }
}
